import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '@src/components/layout/Layout';
import CrewList from './components/CrewList';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import CrewSearchFilterDTO from '@src/adapters/dto/user/CrewSearchFilterDTO';
import { useRegenerateAndResendAvailabilityLinkLazy } from '@src/adapters/hooks/user/useRegenerateAndResendAvailabilityLink';

const PREFIX = 'Template';

const classes = {
  pageTitle: `${PREFIX}-pageTitle`,
  paper: `${PREFIX}-information`,
};

const StyledTitle = styled(Box)(({ theme }) => ({
  padding: '0 20px 20px 20px',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
}));

function Crew() {
  const { execute: regenerate } = useRegenerateAndResendAvailabilityLinkLazy();

  const methods = useForm<CrewSearchFilterDTO>({
    defaultValues: {
      value: '',
      unverifiedOnly: false,
    },
  });

  const {
    control,
    formState: { errors },
  } = methods;

  const handleResend = async () => {
    await regenerate();
  };

  return (
    <Layout>
      <FormProvider {...methods}>
        <form>
          <StyledTitle>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="h4" style={{ paddingRight: '20px' }}>
                Crew
              </Typography>
              <Controller
                name="value"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Search by first, last, email, phone no"
                    error={!!errors.value}
                    style={{ width: '400px', paddingRight: '20px' }}
                  />
                )}
              />
              <Controller
                name="unverifiedOnly"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="Show only unverified"
                  />
                )}
              />
            </Box>
            <Button
              onClick={handleResend}
              color="secondary"
              variant="contained"
              size="medium">
              Recreate and Resend All Availability texts
            </Button>
          </StyledTitle>

          <Paper elevation={8} className={classes.paper}>
            <CrewList />
          </Paper>
        </form>
      </FormProvider>
    </Layout>
  );
}

export default Crew;
